/*
Find which direction the user is scrolling
*/
import { useEffect, useState } from 'react'
export const SCROLL_UP = 'up'
export const SCROLL_DOWN = 'down'
export default (initialDirection: string = SCROLL_DOWN): Record<string, any> => {
  const [scrollDir, setScrollDir] = useState(initialDirection)
  useEffect(() => {
    let lastScrollY = window.pageYOffset

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset
      setScrollDir(scrollY > lastScrollY ? SCROLL_DOWN : SCROLL_UP)
      lastScrollY = scrollY > 0 ? scrollY : 0
    }

    window.addEventListener('scroll', updateScrollDir)
    return () => window.removeEventListener('scroll', updateScrollDir)
  }, [initialDirection])
  return {
    scrollDir,
  }
}